var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 45.43,
    viewBox: "0 0 51 45.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ff5f01;}.cls-1,.cls-2{stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:none;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-1623",
    className: "cls-1",
    d: "M1.25,14.23c-1-.51-1-1.34,0-1.84L23.7.88a4.43,4.43,0,0,1,3.6,0L49.75,12.39c1,.51,1,1.33,0,1.84L27.3,25.74a4.51,4.51,0,0,1-3.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    className: "cls-2",
    d: "M38.9,20.65V38.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-1441",
    className: "cls-2",
    d: "M38.9,38.86a3,3,0,1,1-3,3A3,3,0,0,1,38.9,38.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-2",
    "data-name": "Line",
    className: "cls-2",
    d: "M9.56,13.56l4-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-3",
    "data-name": "Line",
    className: "cls-2",
    d: "M13.61,15.59l4.05-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-1624",
    className: "cls-2",
    d: "M43,18.62V31.78s-6.63,4-17.2,4-17.2-4-17.2-4V18.62"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.ec68f4d15fd4e6b6c73b1c1779800b9b.svg";
export { ForwardRef as ReactComponent };